import Papa from "papaparse"; // For parsing CSV data
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/system";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { creatOrderForPayment, getBillerId, getRoyalityData } from "../../pages/login/action";
import TransitionsModal from "../modal";
import { Table, TableHead, TableBody, TableRow, TableCell, Button } from "@mui/material";
import moment from "moment";
import Sidebar from "../header/index"; // Import the Sidebar component

const Index = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { royalityData } = useSelector((state) => state.loginReducer);
  const { userId } = useSelector((state) => state.commonReducer);
  const navigate = useNavigate();

  const containerRef = useRef(null); // Ref for fullscreen container
  const [openModal, setOpenModal] = useState(true);
  const [collapsed, setCollapsed] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false); // Fullscreen state
  const userName = localStorage.getItem("username");

  useEffect(() => {
    dispatch({
      type: 'COMMON',
      payload: {
        userId: localStorage.getItem('id'),
        storeId: localStorage.getItem('storeId'),
        userType: localStorage.getItem('userType'),
        username: localStorage.getItem('username'),
        email: localStorage.getItem('email'),
      },
    });
  }, [dispatch]);

      React.useEffect(() => {
        if(localStorage.getItem('storeId')){
          fetch(`https://newshopazure.blob.core.windows.net/newshopdev/newshop/${localStorage.getItem('storeId')}.csv`)
          .then(response => response.text())
          .then(csvData => {
            console.log(csvData,"csv")
            Papa.parse(csvData, {
              header: true,
              complete: function (results) {            
                localStorage.setItem("csvData", JSON.stringify(results.data));
              },
              error: function (error) {
                console.error("Error parsing CSV file: ", error);
              }
            });
          })
          .catch(error => {
            console.error("Error fetching CSV file: ", error);
          });
        }
      }, [localStorage.getItem('storeId')]);

  useEffect(()=>{
   if(!userName){
    navigate("/")
   }
  },[userName])

  useEffect(() => {
    if (userId) dispatch(getBillerId(userId));
  }, [userId, dispatch]);

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);

      // Ensure scroll works in fullscreen
      if (document.fullscreenElement) {
        containerRef.current.style.overflow = "auto"; // Enable scroll
        containerRef.current.style.backgroundColor = "#FFFFFF";
        // containerRef.current.style.backgroundColor = window.getComputedStyle(document.body).backgroundColor; // Match background
      } else {
        containerRef.current.style.overflow = "visible"; // Reset overflow
        containerRef.current.style.backgroundColor = "transparent"; // Reset background
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const handleSidebarToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleModalClose = () => {
    if (isRoyaltyFinalDatePassed(royalityData[0]?.royaltyFinalDate)) {
      setOpenModal(true);
    } else {
      setOpenModal(false);
    }
  };

  const isRoyaltyFinalDatePassed = (royaltyFinalDate) => {
    const currentDate = moment();
    const finalDate = moment(royaltyFinalDate);
    return currentDate.isAfter(finalDate);
  };

  const makePayment = async (amount) => {
    const res = await initializeRazorpay();

    if (!res) {
      alert('Razorpay SDK Failed to load');
      return;
    }

    dispatch(
      creatOrderForPayment(
        {
          invoiceNumber: 'invoice_20',
          amount: amount,
          storeId: localStorage.getItem('storeId'),
          notes: 'string',
        },
        (res) => {
          const options = {
            key: 'rzp_test_hNVoPt48fZga5Q',
            amount: res?.amount,
            currency: 'INR',
            name: 'NEW SHOP CSTORE NETWORK PRIVATE LIMITED',
            description: 'Test Transaction',
            image: 'https://thenewshop.in/images/favicon.png',
            order_id: res?.id,
            handler: async function (response) {
              if (response.razorpay_order_id)
                dispatch(getRoyalityData(localStorage.getItem('storeId'), navigate));
              const data = {
                orderCreationId: res?.id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpayOrderId: response.razorpay_order_id,
                razorpaySignature: response.razorpay_signature,
              };
            },
            prefill: {
              email: 'productxventures@gmail.com',
              contact: '9650857683',
            },
            notes: {
              address: '',
            },
            theme: {
              color: '#0000',
            },
            method: {
              netbanking: true,
              card: true,
              upi: true,
            },
            config: {
              display: {
                hide: [
                  { method: 'cardless_emi' },
                  { method: 'paylater' },
                  { method: 'wallet' },
                ],
              },
            },
          };

          const paymentObject = new window.Razorpay(options);
          paymentObject.open();
        }
      )
    );
  };

  const initializeRazorpay = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';

      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };

      document.body.appendChild(script);
    });
  }

  return (
    <div
      ref={containerRef}
      style={{
        height: "100%", // Ensure container height fits fullscreen
        backgroundColor: "transparent",
        transition: "all 0.3s ease", // Smooth transition for background/size changes
      }}
    >
      {royalityData.length > 0 && (
        <TransitionsModal
          header="Royalty Pending"
          children={
            openModal && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Store Name</TableCell>
                    <TableCell>Royalty Pending</TableCell>
                    <TableCell>Month / Year</TableCell>
                    <TableCell>Invoice</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {royalityData.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.storename}</TableCell>
                      <TableCell>{row.royaltyPayable}</TableCell>
                      <TableCell>{row.month_mmm} / {row.year}</TableCell>
                      <TableCell>
                        <a href={row.invoice} target="_blank" rel="noopener noreferrer">
                          View Invoice
                        </a>
                      </TableCell>
                      <TableCell>
                        <Button variant="outlined" onClick={() => makePayment(row?.royaltyPayable)}>Pay now</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )
          }
          handleClose={handleModalClose}
          open={openModal}
        />
      )}
      <Box display="flex">
      {!isFullscreen && <Sidebar onToggle={handleSidebarToggle} collapsed={collapsed} />}
        {/* <Sidebar onToggle={handleSidebarToggle} collapsed={collapsed} /> */}
        <Box
          flex={1}
          style={{ marginTop: '10px', transition: 'margin-left 0.3s' }}
          ml={isFullscreen ? '0px' : collapsed ? '150px' : '300px'}
          // ml={collapsed ? '150px' : '300px'} // Adjust margin based on sidebar state
        >
          <Button
          variant="contained"
          sx={{
            backgroundColor: '#FFD700',
            color: '#333',
            borderRadius: '20px',
            padding: '10px 20px',
            // width: '250px',
            textTransform: 'none',
            fontSize: '16px',
               position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 1000,
            '&:hover': {
                backgroundColor: '#FFD700',
            },
          }}
            onClick={toggleFullscreen}
            // style={{
            //   position: "absolute",
            //   top: "10px",
            //   right: "10px",
            //   zIndex: 1000,
            // }}
          >
            {isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
          </Button>
          <Outlet />
        </Box>
      </Box>
    </div>
  );
};

export default Index;
